<template>
  <div id="successful">
    <!-- 头部 -->
    <!--    <yy-header>预约成功</yy-header>-->
    <div class="main">
      <div class="information">
        <p>您已成功预约<span class="matter"><span style="color: #CBB486" v-show="tag!=undefined">【虚窗帮办】</span>《{{this.itemName}}》</span>事项</p>
        <!-- <p>预约编号：<span class="number">{{data.stRecordId}}</span></p> -->
        <p>请于 <span class="time">{{this.day}} {{this.time}}</span> 前往 {{this.placeName}}办理</p>
        <p>
          地址：{{this.placeAddress}}
          <!-- <a href="">地图</a> -->
        </p>
      </div>
      <div class="tips">
        <div class="tip-tit">温馨提示：</div>
        <p>1. 请携带有效身份证件，在预约时间段前往预约地点办理</p>
        <p>2. 请按时取号签到，过号不候。若需取消，请提前一天取消预约。</p>
      </div>
    </div>

    <!-- 底部 -->
    <!-- <yy-footer></yy-footer> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        itemName: '',
        day: '',
        time: '',
        placeAddress: '',
        placeName: '',
        data: {},
        recordId:'',
        tag:undefined,
      }
    },
    methods: {
      getInformation: async function () {
        let _this = this;
        try {
          const res = await this.$axios.post('/dev/AppFController/getRecordByRecordId', {
            recordId: _this.recordId
          });
          if (res.status === '200') {
            _this.itemName = res.itemName;
            _this.day = res.day;
            _this.time = res.periodStart + '~' + res.periodEnd;
            _this.placeAddress = res.placeAddress;
            _this.placeName = res.placeName;
            _this.tag = res.tag
          }
        } catch (e) {
          this.$toast('用户信息获取失败')
        }
      },

    },
    created() {
      this.recordId = this.$route.query.recordId;
      this.getInformation();
      document.title = '预约成功'
    }

  }
</script>

<style lang="less">
  #successful {
    .main {
      padding-top: 0rem;
    }

    .information {
      font-size: .68rem /* 34/50 */;
      background-color: #fff;
      padding: .4rem /* 20/50 */;

      p {
        line-height: 1.36rem /* 68/50 */;

        .matter {
          font-weight: 700;
          color: rgba(0, 0, 0, 1);
        }

        .number, .time {
          color: @theme-color;
        }
      }

      a {
        color: @theme-color;
      }
    }

    .tips {
      padding: .4rem /* 20/50 */;
      font-size: .56rem /* 28/50 */;
      color: rgba(0, 0, 0, .5);
      line-height: 1.12rem /* 56/50 */;

      .tip-tit {
        color: rgba(0, 0, 0, 1);
      }
    }
  }
</style>
